const doc = [({"da":({"js":({"admin":({"economy":({"account_dimensions":({"account_dimensions":"Kontodimensioner for %{name}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;